import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './login';
import Home from './home';
import About from './about';
import Launches from './launches';
import UploadSignDoc from './upload-sign-doc';
import TemplateDocsList from './components/TemplateDocsList';
import TemplateDocView from './components/TemplateDocView';
import TemplateDocIframe from './components/TemplateDocIframe';
import SignedDocsList from './components/SignedDocsList';
import ClientSignedDocsList from './components/ClientSignedDocsList';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import ClientRoute from './components/ClientRoute';
import { AuthProvider } from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome CSS
import './App.css'
import UpdateTemplateFileForm from './components/UpdateTemplateFileForm';
import UploadChildFileForm from './components/UploadChildFileForm';
import Privacy from './privacy';
import PersonalAgreement from './personal-agreement';
import Landing from './landing';
import LandingPage2 from './landing2';
import ContragentsList from './components/ContragentsList';
import OfficesList from './components/OfficesList';
import OfficeDetailView from './components/OfficeDetailView';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/iframe/template-docs/:id" element={<TemplateDocIframe />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/personal-agreement" element={<PersonalAgreement />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/landing2" element={<LandingPage2 />} />
          
          {/* Protected routes - accessible to all authenticated users */}
          <Route element={<ProtectedRoute />}>
            {/* Routes accessible to both admin and client */}
            <Route path="/" element={
              <>
                <Header />
                <main className="main-content">
                  <Home />
                </main>
              </>
            } />
           {/* <Route path="/about" element={
              <>
                <Header />
                <main className="main-content">
                  <About />
                </main>
              </>
            } /> */}
            
            {/* Admin-only routes */}
            <Route element={<AdminRoute />}>
              <Route path="/upload-sign-doc" element={
                <>
                  <Header />
                  <main className="main-content">
                    <UploadSignDoc />
                  </main>
                </>
              } />
              <Route path="/template-docs" element={
                <>
                  <Header />
                  <main className="main-content">
                    <TemplateDocsList />
                  </main>
                </>
              } />
              <Route path="/offices" element={
                <>
                  <Header />
                  <main className="main-content">
                    <OfficesList />
                  </main>
                </>
              } />
              <Route path="/offices/:officeId" element={
                <>
                  <Header />
                  <main className="main-content">
                    <OfficeDetailView />
                  </main>
                </>
              } />
              <Route path="/template-docs/:id" element={
                <>
                  <Header />
                  <main className="main-content">
                    <TemplateDocView />
                  </main>
                </>
              } />
              <Route path="/template-docs/:id/signed" element={
                <>
                  <Header />
                  <main className="main-content">
                    <SignedDocsList />
                  </main>
                </>
              } />
              <Route path="/template-docs/:id/update-file" element={
                <>
                  <Header />
                  <main className="main-content">
                    <UpdateTemplateFileForm />
                  </main>
                </>
              } />
              <Route path="/template-docs/:id/upload-child-file" element={
                <>
                  <Header />
                  <main className="main-content">
                    <UploadChildFileForm />
                  </main>
                </>
              } />
            </Route>
            
            {/* Client-only routes */}
            <Route element={<ClientRoute />}>
              <Route path="/launches" element={
                <>
                  <Header />
                  <main className="main-content">
                    <Launches />
                  </main>
                </>
              } />
              <Route path="/contragents" element={
                <>
                  <Header />
                  <main className="main-content">
                    <ContragentsList />
                  </main>
                </>
              } />
              <Route path="/launches/:id/signed-docs" element={
                <>
                  <Header />
                  <main className="main-content">
                    <ClientSignedDocsList />
                  </main>
                </>
              } />
            </Route>
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;